import React from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectFullName } from "../../reducer/authSlice";

import QuestionNoList from "../../components/QuestionNoList";
import Timer from "../Timer";
import Collapsible from "react-collapsible";
import IconButton from "@mui/material/IconButton";
import Menu from '@mui/icons-material/Menu';
import ahGreenDotLogo from "../../images/assesshub_logo_green_dot.svg";
const _useStyles = makeStyles((_theme) => ({
  root: {
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
}));

const AppBar = (props) => {
  const {
    showModel,
    ImageAlertShowModal,
    AudioAlertShowModal,
    NoFaceAlertModal,
    NoMatchAlertModal,
    MultipleFaceAlertModal,
    _value,
    showFinishModalDetail,
    examDetail,
    setTimeoutModelShow,
    setTimeoutModelOneMinuteShow,
    questionNo,
    testData,
    setQuestionNo,
    setQuestionChange,
    navFlag,
    isVideoUploading,
    isTimeUp,
    setIsTimeUp,
    isVideoInterviewTest,
    isRecordingDone,
    setIsRecordingDone,
    utcTestStartTime,
    setUtcTestStartTime,
    utcTestFinishTime,
    setUtcTestFinishTime,
    isWindowSwitched,
    isPhotoMatchingInProgress,
    isPhotoServerPaused,
    isFullscreenExited,
  } = props;
  const userName = useSelector(selectFullName);

  const instructionClick = () => {
    props.setViewInstruction(true);
  };

  return (
    <>
      <div style={{ borderBottom: "1px " }} className="row qa-header navbar-expand-xl button-text app-border">
        <div className="col-xs-12 visible-xs ">
          <div className="logo-sec">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#">
              <img alt="" src={ahGreenDotLogo} style={{ height: "35px" }} className="img-responsive center-block" />
            </a>
          </div>
        </div>
        <div style={{ width: "100%", padding: "7px 0" }}>
          <div id="c3">
            <div className="logo-sec">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#">
                <img alt="" src={ahGreenDotLogo} style={{ height: "35px" }} className="img-responsive" />
              </a>
            </div>
          </div>
          <div id="c1">
            <ul className="list-inline new-li header-links header-links-two qnum-links ">
              <li className="nav-line-right">
                <h5 style={{ marginLeft: "10px" }}>
                  <strong>{userName}</strong>
                </h5>
              </li>
              <li className="nav-line-right">
                <h5>
                  <strong>{props.examDetail[0].instancename}</strong>
                </h5>
              </li>
              <li className="nav-line-right">
                <h5 style={{ cursor: "pointer" }} onClick={() => instructionClick()}>
                  <strong>{examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "Survey" : "Test"} Instructions</strong>
                </h5>
              </li>
              <li style={{ paddingRight: "0px" }}>
                <h5>
                  <strong>
                    {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "Statement" : "Question"} {questionNo} / {testData.length}
                  </strong>
                </h5>
              </li>
              <QuestionNoList
                themeType={props.themeType}
                testData={testData}
                setQuestionNo={setQuestionNo}
                questionNo={questionNo}
                setQuestionChange={setQuestionChange}
                navFlag={navFlag}
              />
            </ul>
          </div>
          <div id="c2">
            {utcTestFinishTime && utcTestStartTime ? (
              <h4 style={{ color: "#B45E9B" }}>
                <strong>
                  Time :{" "}
                  <Timer
                    showModel={showModel}
                    ImageAlertShowModal={ImageAlertShowModal}
                    AudioAlertShowModal={AudioAlertShowModal}
                    NoFaceAlertModal={NoFaceAlertModal}
                    NoMatchAlertModal={NoMatchAlertModal}
                    MultipleFaceAlertModal={MultipleFaceAlertModal}
                    showFinishModalDetail={showFinishModalDetail}
                    examDetail={examDetail}
                    setTimeoutModelShow={setTimeoutModelShow}
                    setTimeoutModelOneMinuteShow={setTimeoutModelOneMinuteShow}
                    isVideoUploading={isVideoUploading}
                    isTimeUp={isTimeUp}
                    setIsTimeUp={setIsTimeUp}
                    isVideoInterviewTest={isVideoInterviewTest}
                    isRecordingDone={isRecordingDone}
                    setIsRecordingDone={setIsRecordingDone}
                    utcTestStartTime={utcTestStartTime}
                    setUtcTestStartTime={setUtcTestStartTime}
                    utcTestFinishTime={utcTestFinishTime}
                    setUtcTestFinishTime={setUtcTestFinishTime}
                    isWindowSwitched={isWindowSwitched}
                    isPhotoMatchingInProgress={isPhotoMatchingInProgress}
                    isPhotoServerPaused={isPhotoServerPaused}
                    isFullscreenExited={isFullscreenExited}
                  />
                  &nbsp;
                </strong>
              </h4>
            ) : null}
          </div>
        </div>
      </div>

      <div className="qa-header navbar-expand-xl btn-inst app-border">
        <Collapsible
          trigger={
            <div className="row">
              <div className="col-xs-12">
                <div className="logo-sec">
                  <ul className="list-inline header-links qnum-links ">
                    <li>
                      <IconButton edge="start" style={{ display: "inline" }}>
                        <Menu />
                      </IconButton>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a style={{ display: "inline" }} href="#">
                        {/* eslint-disable-next-line jsx-a11y/alt-text */}
                        <img
                          alt=""
                          style={{ display: "inline-block", width: "auto", height: "35px" }}
                          src={ahGreenDotLogo}
                          className="img-responsive center-block"
                        />
                      </a>
                    </li>
                    <li style={{ float: "right", marginTop: "7px" }}>
                      {utcTestFinishTime && utcTestStartTime ? (
                        <h5 style={{ color: "#B45E9B" }} className="text-timer ">
                          <strong>
                            Time :{" "}
                            <Timer
                              showModel={showModel}
                              ImageAlertShowModal={ImageAlertShowModal}
                              AudioAlertShowModal={AudioAlertShowModal}
                              NoFaceAlertModal={NoFaceAlertModal}
                              NoMatchAlertModal={NoMatchAlertModal}
                              MultipleFaceAlertModal={MultipleFaceAlertModal}
                              examDetail={examDetail}
                              setTimeoutModelShow={setTimeoutModelShow}
                              setTimeoutModelOneMinuteShow={setTimeoutModelOneMinuteShow}
                              isVideoUploading={isVideoUploading}
                              isTimeUp={isTimeUp}
                              setIsTimeUp={setIsTimeUp}
                              isVideoInterviewTest={isVideoInterviewTest}
                              isRecordingDone={isRecordingDone}
                              setIsRecordingDone={setIsRecordingDone}
                              utcTestStartTime={utcTestStartTime}
                              setUtcTestStartTime={setUtcTestStartTime}
                              utcTestFinishTime={utcTestFinishTime}
                              setUtcTestFinishTime={setUtcTestFinishTime}
                              isWindowSwitched={isWindowSwitched}
                              isPhotoMatchingInProgress={isPhotoMatchingInProgress}
                              isPhotoServerPaused={isPhotoServerPaused}
                              isFullscreenExited={isFullscreenExited}
                            />
                          </strong>
                        </h5>
                      ) : null}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          }
        >
          <div className="row">
            <div className="col-xs-12">
              <ul className="list-inline header-links qnum-links ">
                {/* <li style={{top:'7px',paddingRight:'11px'}}><div><CloseIcon onClick={() => props.onSubmit('001')} style={{cursor: 'pointer'}} /></div></li> */}
                <li>
                  <h5 className="text-usname">
                    <strong>{userName}&nbsp;&nbsp;</strong>
                  </h5>
                </li>
                <li>
                  <h5 className="text-usname">
                    <strong>{props.examDetail[0].instancename}</strong>
                  </h5>
                </li>
                {/* <li><h5 style={{color:"#B45E9B"}} className="text-timer "><strong style={{color:""}}>Time : <Timer examDetail={examDetail} setTimeoutModelShow={setTimeoutModelShow} /></strong></h5> </li> */}
              </ul>
            </div>
            {/* <div className="col-xs-12">
            <ul className="list-inline header-links qnum-links ">
              <li><h5 style={{color:"#B45E9B"}} className="text-timer "><strong>Time : <Timer  showModel={showModel} ImageAlertShowModal={ImageAlertShowModal} AudioAlertShowModal={AudioAlertShowModal} NoFaceAlertModal={NoFaceAlertModal} NoMatchAlertModal={NoMatchAlertModal} MultipleFaceAlertModal={MultipleFaceAlertModal} examDetail={examDetail} setTimeoutModelShow={setTimeoutModelShow} setTimeoutModelOneMinuteShow={setTimeoutModelOneMinuteShow} /></strong></h5> </li>
            </ul>
          </div> */}
            <div className="col-xs-12">
              <ul className="list-inline header-links qnum-links">
                <li>
                  <h5 className="text-usname">
                    <strong>
                      Question {questionNo} / {testData.length}
                    </strong>
                  </h5>
                </li>
                <QuestionNoList
                  style={{ textAlign: "center" }}
                  themeType={props.themeType}
                  testData={testData}
                  setQuestionNo={setQuestionNo}
                  questionNo={questionNo}
                  setQuestionChange={setQuestionChange}
                  navFlag={navFlag}
                />
                <li>
                  <h5 style={{ cursor: "pointer", textDecoration: "none", margin: "4px" }} color="inherit" onClick={() => instructionClick()}>
                    <strong>Test Instructions</strong>
                  </h5>
                </li>
              </ul>
            </div>
          </div>
        </Collapsible>
      </div>
    </>
  );
};

export default AppBar;
